import { resolveProcodocsRequest } from '../../../../../lib/fetchApi'
import { useDispatch, useSelector } from 'react-redux'
import { notificationActions } from '../../../../../store/notifications'
import Button from '../../../../common/Button'
import { useState } from 'react'
import BodySimpleModalV3 from '../../../../common/modal/BodySimpleModalV3'

export default function ResolveRequest({request, refreshRequests}) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const caseId = useSelector(state => state.case.activeCase.case.id)
    const [isLoading, setIsLoading] = useState(false)

    async function resolveRequestHandler() {
        setIsLoading(true)
        try {
            let resolve = await resolveProcodocsRequest(userToken, caseId, request.id)
            if (resolve?.errorMessage) {
                dispatch(notificationActions.setError(resolve))
            } else {
                if (refreshRequests) {
                    refreshRequests()
                }
            }
        } finally {
            setIsLoading(false)
        }
    }
    return <BodySimpleModalV3 message={'Resolve Note'}>
        <Button title='Resolve Note' btnStyle='btn_small' click={resolveRequestHandler} isLoading={isLoading}><i className='ti ti-rosette-discount-check'></i></Button>
    </BodySimpleModalV3>
}